module.exports = __webpack_public_path__ + "img/page-not-found.a1f5fe9a.svg";